import React, { useContext } from "react"
import { StateContext } from "provider/StateProvider"
import {
  ButtonWrapper,
  Close,
  Container,
  ImageBox,
  ImageWrapper,
  NextImage,
  Pagination,
  PrevImage,
  Title,
  Wrapper,
} from "./styles"
import { Swiper, SwiperSlide } from "swiper/react"

export const Fancybox = ({ index, data }) => {
  const { setFancyboxOpen } = useContext(StateContext)

  const options = {
    loop: true,
    speed: 0,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".next-image",
      prevEl: ".prev-image",
    },
    pagination: {
      el: ".pagination",
      type: "fraction",
    },
    onInit: swiper => swiper.slideTo(index),
  }

  return (
    <Container>
      <Close onClick={() => setFancyboxOpen(false)} />
      <Wrapper>
        <ButtonWrapper>
          <PrevImage className="prev-image" />
        </ButtonWrapper>
        <ImageWrapper>
          <Title>Galeria zdjęć</Title>
          <Swiper {...options}>
            {data.map((image, i) => (
              <SwiperSlide key={i}>
                <ImageBox>{image}</ImageBox>
              </SwiperSlide>
            ))}
          </Swiper>
          <Pagination className="pagination" />
        </ImageWrapper>
        <ButtonWrapper>
          <NextImage className="next-image" />
        </ButtonWrapper>
      </Wrapper>
    </Container>
  )
}
